module.exports = __webpack_public_path__ + "static/law-pay-a9e5bc4c078f182861bc75267aeaf688.png";